<template>
  <div id="app">
    <div class="tab">
      <ul>
        <li><span class="active">正在搜索比对任务</span></li>
        <li><span @click="toCompleteTab" style="cursor:pointer">已完成任务</span></li>
      </ul>
    </div>
    <div class="cnt">
      <ul v-show="!isLoading">
        <li v-for="(process,key) in processList" :key="key" style="magrin-top:10px">
          <img class="pic" :src="process.pictureList[0].link"/>
          <div class="info">
            <div class="title">{{process.title}}</div>
            <div class="web_lable">比对网站</div>
            <div class="webs">
              <span v-for="(web,key2) in process.platformWebList" :key="key2">
                <span v-if="key2<=10">{{web.title}}&nbsp;</span>
                <span v-if="key2==11">等...&nbsp;</span>
              </span>
            </div>
            <div class="date">时间：{{process.startDate}}&nbsp;至&nbsp;{{process.endDate}}</div>
          </div>
          <div class="opt">
            <div class="label">已查到相似处</div>
            <div class="count">{{process.resCount}}</div>
            <div class="searching">正在对比中...</div>
            <div class="btns">
              <button class="btn" v-on:click="check(process.taskId)">查看</button>
              <button class="btn red" v-on:click="close(process.taskId,process.title)">结束任务</button>
            </div>
          </div>
          <div class="clear_both"></div>
        </li>

      </ul>
      <div v-show="isLoading">正在加载...</div>
      <div style="color:#666;padding-top:100px;padding-left:20px" v-show="emptyData">抱歉，您没有进行中的任务</div>
    </div>

  </div>
  
</template>

<script>
import {processApi,closeTask} from '@/service/allApi'
import { taskDetailApi } from '../../service/allApi';
export default {
  data(){
    return {
      processList:[],
      isLoading:true,
      emptyData:false,
      dialogVisible:false
    }
  },
  mounted(){
 
    this.loadTask();
  },
  methods: {
    toCompleteTab(){
      window.parent.toUrl("/my?page=history")
    },
    check(taskId){
      const url  =  "/check?taskId=" + taskId
      this.$router.push(url)
    },
    close(taskId,title){
      window.parent.closeTask(taskId,title)
     // this.dialogVisible = true
    //  const options = {
     //   taskId:taskId
    //  }
      //const res = await closeTask(options)

    },
    loadTask(){
      
      const options = {
        status:0
      }
      const that = this
      that.isLoading = false
      processApi(options).then((res)=>{
        // console.log(res)
        if(res.data.code == 100){
        console.log(res.data.list)
          if(res.data.list && res.data.list.length > 0){
            that.processList = res.data.list
          }else{
            that.emptyData = true
          }
          
        }
        that.isLoading = false
      }).catch((error)=>{
        that.$message.error("系统出错");
        that.isLoading = false
      })
    }
  },
}
</script>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Searching.css"></style>


// WEBPACK FOOTER //
// src/components/iframe/Searching.vue